import Spacer from '@berlitz/spacer'
import * as React from 'react'
import { RectLoader } from '../Loader'
import { Wrapper } from './style'

const ViewMaterialLoader: React.FC = () => {
  return (
    <Wrapper>
      <RectLoader width="100" height="15" />
      <br />
      <RectLoader width="160" height="25" />

      <Spacer size="xs" />

      <div className="select-loader">
        <div>
          <RectLoader width="100" height="15" />
          <br />
          <RectLoader width="180" height="25" />
        </div>

        <div>
          <RectLoader width="100" height="15" />
          <br />
          <RectLoader width="140" height="25" />
        </div>
      </div>
    </Wrapper>
  )
}

export default ViewMaterialLoader
